export const getFormIdByPriceCountry = (priceCountry?: string) => {
    switch (priceCountry) {
        case 'US':
            return 4211;
        case 'IN':
            return 4321;
        // Use US formId for other English-speaking geos
        case 'UK':
        case 'AU':
        case 'CA':
        case 'NZ':
        case 'SG':
        case 'ZA':
            return 4211;
        // If price_country is not yet initialized via UDData, return undefined
        case undefined:
            return undefined;
        // Fallback to US if traffic comes in from geos that don't have their own formId yet
        default:
            return 4211;
    }
};
